import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mobile-menu" }
const _hoisted_2 = { class: "mobile-menu__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLinks = _resolveComponent("MainLinks")!
  const _component_ArticleList = _resolveComponent("ArticleList")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("nav", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mobile-menu__head" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_MainLinks),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mobile-menu__breaker" }, null, -1)),
          _createVNode(_component_ArticleList)
        ])
      ], 512), [
        [_vShow, _ctx.showMobileMenu]
      ])
    ]),
    _: 1
  }))
}